import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { CommonModule } from "@angular/common";
import { BusinessPartnersFiltersComponent } from "app/modules/components/filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "app/modules/components/filters/configuration-filters/configuration-filters.component";
import { FormGroup, FormBuilder, ReactiveFormsModule } from "@angular/forms";
import { RoutesFiltersComponent } from "app/modules/components/filters/routes-filters/routes-filters.component";
import BusinessPartnerGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-group/business-partner-group.entity";
import { BusinessPartnerGroupService } from "../../../business-partner-group/business-partner-group.service";
import { MultiLocationFiltersComponent } from "app/modules/components/filters/multi-location-filters/multi-location-filters.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { LocationTwoService } from "app/modules/components/locations/location-two/location-two.service";
import {
  LocationThreeAttributes,
  LocationTwoAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { MatSelectModule } from "@angular/material/select";
import { getCode } from "app/utils/method";
import { LocationThreeService } from "app/modules/components/locations/location-three/location-three.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { IFilters } from "app/modules/components/filters/interfaces/filterInterface";
import { map, Observable } from "rxjs";
import { BusinessPartnerService } from "../../business-partner.service";
import { FuseConfirmationService } from "@fuse/services/confirmation/confirmation.service";

@Component({
  selector: "app-address-export",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    ConfigurationFiltersComponent,
    BusinessPartnersFiltersComponent,
    RoutesFiltersComponent,
    MultiLocationFiltersComponent,
    MatFormFieldModule,
    MatSelectModule,
  ],
  templateUrl: "./export-address.component.html",
})
export class AddresExportComponent {
  getCode = getCode;
  form: FormGroup;
  groupList: BusinessPartnerGroupAttributes[] = [];
  listlocationTwo: LocationTwoAttributes[] = [];
  listFilterLocationTwo: LocationTwoAttributes[] = [];
  listlocationThree: LocationThreeAttributes[] = [];
  listFilterLocationThree: LocationThreeAttributes[] = [];
  listFilterGroupList: BusinessPartnerGroupAttributes[] = [];

  constructor(
    private fb: FormBuilder,
    private readonly groupService: BusinessPartnerGroupService,
    private readonly locationOneService: LocationTwoService,
    private readonly locationThreeService: LocationThreeService,
    private readonly businessService: BusinessPartnerService,
    private fuseConfirmationService: FuseConfirmationService,
    public dialogRef: MatDialogRef<AddresExportComponent>,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      businessPartnerGroupId: [],
      subRouteId: [],
      routeId: [],
      routeAreaId: [],
      locationOneIds: [[]], // Países
      locationTwoIds: [[]], // Departamentos
      locationThreeIds: [[]], // Ciudades
    });
  }

  ngAfterViewInit(): void {
    this.fetchGroup();
    this.fetchAllDepartments();
    this.fetchAllCities();
  }

  private fetchGroup(): void {
    this.groupService.findToComboBox().subscribe({
      next: (res) => {
        this.groupList = res.data;
        this.listFilterGroupList = this.groupList.slice();
      },
      error: (error) => {
        const errorMessage = error?.error?.message || "Error al cargar grupos";
        this.snackBar.open(errorMessage, "Cerrar", {
          duration: 5000,
          panelClass: ["error-snackbar"],
        });
      },
    });
  }

  private fetchAllDepartments(): void {
    this.locationOneService.findToComboBox().subscribe({
      next: (res) => {
        this.listlocationTwo = res.data;
        this.listFilterLocationTwo = this.listlocationTwo.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err?.error?.message || "Error al cargar los departamentos",
          "Cerrar",
          {
            duration: 3000,
            panelClass: ["error-snackbar"],
          }
        );
      },
    });
  }

  private fetchAllCities(): void {
    this.locationThreeService.findToComboBox().subscribe({
      next: (res) => {
        this.listlocationThree = res.data;
        this.listFilterLocationThree = this.listlocationThree.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err?.error?.message || "Error al cargar las ciudades",
          "Cerrar",
          {
            duration: 3000,
            panelClass: ["error-snackbar"],
          }
        );
      },
    });
  }

  getDisplayValue(
    list: { name: string; code: string }[],
    selectedValues: string[],
    property: string = "name"
  ): string {
    if (!selectedValues || !selectedValues.length) return "";
    if (selectedValues.length === 1) {
      const item = list.find((d) => d.code === selectedValues[0]);
      return item ? item[property] : "";
    }
    return `${selectedValues.length} seleccionados`;
  }

  onExport(): void {
    const filters: IFilters = this.form.value;
    this.checkData(filters).subscribe((total) => {
      if (total > 0) {
        this.dialogRef.close(filters);
      } else {
        this.snackBar.open("No hay datos para exportar", "Cerrar", {
          duration: 5000,
          panelClass: ["info-snackbar"],
        });
      }
    });
  }

  private checkData(filters: IFilters): Observable<number> {
    return this.businessService
      .findAllWithCount(
        { currentPage: 1, limitPerPage: 1, search: "" },
        false,
        [],
        "",
        filters
      )
      .pipe(map((res) => res?.data?.[0]?.pageInfo?.[0]?.total ?? 0));
  }

  onExportConfirm(): void {
  const confirmation = this.fuseConfirmationService.open({
    title: "Atención: Exportación masiva",
    message: "Va a exportar todas las direcciones. Esto puede tardar algunos minutos y generar una gran cantidad de datos. ¿Desea continuar?",
    icon: {
      show: true,
      name: "heroicons_outline:exclamation-triangle",
      color: "warn",
    },
    actions: {
      confirm: {
        label: "Continuar",
        color: "warn",
      },
      cancel: {
        label: "Cancelar",
      },
    },
  });

  confirmation.afterClosed().subscribe((result) => {
    if (result === "confirmed") {
      this.onExport();
    }
  });
}

}
